<template>
    <section class="app-main">

        <div class="top-bar">
            <el-button @click="handleShow()" type="primary" plain style="width:120px">添加</el-button>
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table ref="multipleTable" :data="tableData"  max-height="530" style="width: 100%">
                <el-table-column label="语言"  align="center" v-if="['4', '6'].includes(section) ">
                    <template slot-scope="scope">
                        <span v-if="scope.row.language == 'zh'">中文</span>
                        <span v-else>英文</span>
                    </template>
                </el-table-column>
                <el-table-column label="图片"  align="center" >
                    <template slot-scope="scope">
                        <m-img :src="scope.row.pic_url" :width="300" :height="150" />
                    </template>
                </el-table-column>
                <el-table-column  prop="link" align="center" label="链接"  ></el-table-column>
                <el-table-column  prop="site" align="center" label="位置"  sortable>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.site" @change="handleSite(scope.row)" size="mini" style="width:80px"></el-input>
                    </template>
                </el-table-column>
                <el-table-column  prop="updated_at" align="center" label="操作时间"></el-table-column>
                <el-table-column prop="totalMoney"  align="center" label="操作" >
                    <template slot-scope="scope">
                        <el-button  @click="handleShow(scope.row)" type="success" plain size="mini">修改</el-button>
                        <el-button  @click="handleDel(scope.row, scope.$index)" type="danger" plain size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

       <el-dialog title="编辑图片" :visible.sync="dialog" width="800px">
            <el-card class="m-bottom-4">
                <el-row class="m-bottom-4">
                    <el-col :span="4" class="input-left">
                        主题图片：
                    </el-col>
                    <el-col :span="20">
                        <img-upload :img.sync="img" file-name="ThemeMooby" :width="300" :height="150"></img-upload>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="4" class="input-left">图片要求：</el-col>
                    <el-col  :span="20" class="input-left tips"> 格式：JPG、JPEG、PNG; 尺寸：{{this.size}}; 大小：1M以内</el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="4"  class="input-left">图片链接：</el-col>
                    <el-col :span="20" class="input-left">
                        <el-input v-model="link" style="width:300px"></el-input>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="4"  class="input-left">图片位置：</el-col>
                    <el-col :span="20" class="input-left">
                        <el-input @change="$emit('giftBanner', site)" v-model="site" style="width:300px"></el-input>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4" v-if="['4', '6'].includes(section) ">
                    <el-col :span="4"  class="input-left">图片语言：</el-col>
                    <el-col :span="20" class="input-left">
                        <el-radio v-model="language" label="zh" border>中文</el-radio>
                        <el-radio v-model="language" label="en" border>英文</el-radio>
                    </el-col>
                </el-row>
            </el-card>
            <span slot="footer" class="dialog-footer">
                <el-button type="info"    plain @click="dialog = false" style="width:120px;margin-right:100px">取 消</el-button>
                <el-button type="primary" @click="handleBtn()" style="width:120px">确 定</el-button>
            </span>
        </el-dialog>


    </section>
</template>



<script>
import ImgUpload from '@/components/m-upload.vue'
import { theme_list, theme_add, theme_put, theme_del } from '@/api/market.js'
import MImg  from '@/components/Image'
export default {
    components: { ImgUpload, MImg },
    props: [ 'section', 'size'],
    data() {
        return {
            tableData: [],
            id: '',
            img: {},
            site: 1,
            link: '',
            language: 'zh',
            dialog: false,

        }
    },
    methods: {
         // 获取 图片列表
        getData() {
            let params = {
                cid: this.section
            }
            theme_list(params).then(res => {
                if(res) {
                    this.tableData = res.data
                }
            })
        },
         // 显示添加修改弹窗
        handleShow(row){
            if(row){
                this.dialog = true
                this.id     = row.id
                this.link   = row.link
                this.site   = row.site
                this.language = row.language
                this.img    = {
                    pic_id  : row.pic,
                    url     : row.pic_url
                }
                this.$emit('giftBanner', this.site)
            }else{
                this.dialog = true
                this.id     = ''
                this.link   = ''
                this.site   = ''
                this.img    = {}
                this.language = 'zh'
                this.$emit('giftBanner', this.site)
            }
        },
        // 弹窗里面 点击确定
        handleBtn(){
            this.dialog = false
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
            
        },
        // 添加分类函数
        handleAdd(){
            let params = {
                cid: this.section,
                site:this.site,
                link: this.link,
                pic: this.img.pic_id
            } 
            if(['4', '6'].includes(this.section) ) {
                params.language = this.language
            }
            theme_add(params).then(res => {
                if(res){
                    this.getData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
         // 添加分类函数
        handlePut(){
            let params = {
                cid: this.section,
                site:this.site,
                link: this.link,
                pic: this.img.pic_id
            }
            if(['4', '6'].includes(this.section)) {
                params.language = this.language
            }
            theme_put(this.id, params).then(res => {
                if(res){
                    this.getData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 列表修改位置
        handleSite(row) {
            let params = {
                site:row.site,
            }
            theme_put(row.id, params).then(res => {
                if(res){
                    this.getData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 点击删除 
        handleDel(item, index){
            this.$confirm(`此操作将删除图片，是否继续?`, '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                theme_del(item.id).then(res => {
                    this.$message({type:"success",message:res.msg})
                    this.tableData.splice(index, 1)
                })
            })
        },
    },
    created() {
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    .input-left {
        height: 40px;
        line-height: 40px;
        min-width:80px ;
    }
    .tips {
        color: #909399;
        font-size: 14px;
    }
    /deep/  .el-input--mini .el-input__inner  {
        text-align: center;
        width: 60px;
    }  
    .dialog-footer {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
